module.exports = "/_next/static/images/success-plus-graph-423e0485df61edef1b80339fbe435183.png";